import { marker } from '@jsverse/transloco-keys-manager/marker';

export const I18nKeys = {
	Notifications: {
		Title: marker('notifications.title')
	}
};
